export interface NotificationItemApiResource {
  id: string;
  notification_type: string;
  title: string;
  body: string;
  action_url: string | null;
  is_read: boolean;
  created_at: string;
}

export interface NotificationPageApiResource {
  items: NotificationItemApiResource[];
  page: number;
  page_size: number;
  total_items: number;
}

export interface UnreadNotificationCountApiResource {
  unread: number;
}

export interface NotificationItem {
  id: string;
  notificationType: string;
  title: string;
  body: string;
  actionUrl: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationPage {
  items: NotificationItem[];
  page: number;
  pageSize: number;
  totalItems: number;
}

export function mapApiResourceToNotificationItem(
  resource: NotificationItemApiResource
): NotificationItem {
  return {
    id: resource.id,
    notificationType: resource.notification_type,
    title: resource.title,
    body: resource.body,
    actionUrl: resource.action_url,
    isRead: resource.is_read,
    createdAt: resource.created_at,
  };
}

export function mapApiResourceToNotificationPage(
  resource: NotificationPageApiResource
): NotificationPage {
  return {
    items: resource.items.map(mapApiResourceToNotificationItem),
    page: resource.page,
    pageSize: resource.page_size,
    totalItems: resource.total_items,
  };
}
